
import { IAppState } from 'types'
import actionTypes from '../actionTypes'
import { AnyAction } from 'redux'

const initialState: IAppState = {
    loading: false,
    loaded: false,
    locationHistory: [],
    routes: undefined
}

export default function appReducer(state = initialState, action: AnyAction): IAppState {
    switch (action.type) {

        case actionTypes.APP_LOADING_BAR_START:
            return {
                ...state,
                loading: true
            }
        case actionTypes.APP_LOADING_BAR_END:
            return {
                ...state,
                loading: false
            }

        case actionTypes.APP_LOADED_START:
            return {
                ...state,
                loaded: false
            }

        case actionTypes.APP_LOADED_SUCCESS:
            return {
                ...state,
                loaded: true
            }

        case actionTypes.APP_RESET:
            return {
                ...initialState,
            }

        case actionTypes.APP_ADD_LOCATION_HISTORY:
            if (state.locationHistory.length > 0 && state.locationHistory[0].pathname === action.payload.location.pathname)
                return state

            return {
                ...state,
                locationHistory: [action.payload.location, ...state.locationHistory].slice(0, 5)
            }

        case actionTypes.APP_SET_ROUTES:
            return {
                ...state,
                routes: action.payload.routes
            }

        default:
            return state
    }
};